import { theme } from '@academica-box/plugins/theme'

export default defineNuxtPlugin(theme)
